require('./bootstrap');

window.Vue = require('vue');

import Vue                       from 'vue';
import VueSweetalert2            from 'vue-sweetalert2';
import {VPopover, VTooltip}      from 'v-tooltip';
import vueNumeralFilterInstaller from 'vue-numeral-filter';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.directive('tooltip', VTooltip);
Vue.component('v-popover', VPopover);

Vue.use(VueSweetalert2);
Vue.use(vueNumeralFilterInstaller);

new Vue({
    el: '#calculator',
    data: {
        input: {
            frequencies: null,
            terms: 52,
            cash: 0,
        },
        globals: {
            flat_rate: 0,
            arrangement_fee: 0,
        },
        frequencies: null,
        terms: [],
        termUnit: null,
        selectedTermIndex: -1,
        selectTerms: [],
        appUrl: process.env.MIX_APP_URL,
        post_url: '',
        product_id: 0,
        productType: '',
        styles: [],
        combinations: [],
        swatchNotSelected: true,
        combinationSelected: false,
        sofaSelection: {
            swatch: {
                id: 0,
                product_id: 0,
                style_id: 0,
                image_path: '',
                title: '',
            },
            style: {
                id: 0,
                product_id: 0,
                title: '',
            },
        },
        baseTypes: [],
        bedSelection: {
            bedBase: {},
            storage: {},
            mattress: {},
            headboard: {},
            swatch: {},
        },
        product_attributes: [],
        product_subitems: [],
        originalPrice: '',
        stock_status_id: null,
        voucherPricing: [
            {
                id: null,
                product_id: null,
                attribute_id: null,
                title: null,
                cash_price: null,
                created_at: null,
                updated_at: null,
            },
        ],
    },
    methods: {
        calculateApr() {
            let terms = this.input.terms;
            let weeks = [];

            if (this.input.frequencies === 'Monthly') {
                terms = Math.trunc(terms * 4.34524);
            }

            let repaymentMultiplier = 1 + (this.globals.flat_rate * (terms / 52));

            for (let week = 0; week < terms; week++) {
                weeks[week] = 100 * repaymentMultiplier / terms;
            }

            let irr = this.calculateIrr(100, weeks);
            let apr = Math.pow(irr + 1, 52) - 1;

            return apr * 100;
        },
        calculateIrr(investment, flow) {
            for (let n = 0; n < 100; n += 0.000001) {
                let pv = 0;

                for (let i = 0; i < flow.length; i++) {
                    pv = pv + flow[i] / Math.pow(1 + n, i + 1);
                }

                if (pv <= investment) {
                    return n;
                }
            }
        },
        calculateDeposit() {
            let deposit = (Math.round((this.input.cash * 0.05) / 5) * 5);

            switch (this.productType) {
                case 'car':
                    deposit = (Math.round((this.input.cash * 0.07) / 5) * 5);
                    break;

                case 'carpet':
                case 'blinds':
                case 'voucher':
                    deposit = 0;
                    break;
            }

            return deposit;
        },
        calculateLoanDetails() {
            let flatRate = 19;
            let arrangementFee = 40;

            if (this.productType === 'retail' || this.productType === 'sofa' || this.productType === 'bed' || this.productType === 'carpet' || this.productType === 'blinds') {
                flatRate = 36; // Fixed issue with Admin/Website calculations discrepancy - 30/09/21

                if (this.input.terms >= 52) {
                    arrangementFee = 25;
                }

                if (this.productType === 'carpet' || this.productType === 'blinds') {
                    arrangementFee = 0;
                }
            } else if (this.productType === 'voucher' || this.productType === 'experience') {
                arrangementFee = 0;
                flatRate = 80;
            }

            this.globals.flat_rate = flatRate;
            this.globals.arrangement_fee = 0; //Disabled arrangementFee as per easybuys request
        },
        calculateInstallments(totalValue) {
            switch (this.input.frequencies) {
                case 'Weekly':
                case 'Monthly':
                    return totalValue / this.input.terms;

                case 'Fortnightly':
                    return totalValue / (this.input.terms / 2);

                case '4 weekly':
                    return totalValue / (this.input.terms / 4);
            }
        },
        calculateFinalInstallment(installments, totalValue) {
            if (installments !== undefined) {
                if (installments !== installments.toFixed(2)) {
                    switch (this.input.frequencies) {
                        case 'Weekly':
                        case 'Monthly':
                            return (totalValue - (installments.toFixed(2) * (this.input.terms - 1)));

                        case 'Fortnightly':
                            return (totalValue - (installments.toFixed(2) * ((this.input.terms / 2) - 1)));

                        case '4 weekly':
                            return (totalValue - (installments.toFixed(2) * ((this.input.terms / 4) - 1)));
                    }
                }
            }

            return 0;
        },
        getFrequencies() {
            axios.get(`${process.env.MIX_APP_URL}/api/get-frequencies`).then(response => {
                this.frequencies = response.data;
                this.input.frequencies = this.frequencies.at(0);
            }).catch(error => (
                console.error(error)
            ));
        },
        getTerms() {
            axios.get(`${process.env.MIX_APP_URL}/api/get-terms?product_type=${this.productType}`).then(response => {
                this.terms = response.data;
                this.selectTerms = this.input.frequencies === 'Monthly' ? this.terms.monthly : this.terms.weekly;
                this.input.terms = this.selectTerms.at(-1);
                this.termUnit = this.input.frequencies === 'Monthly' ? 'months' : 'weeks';
            }).catch(error => (
                console.error(error)
            ));
        },
        onFrequencyChange(event) {
            switch (event.target.value) {
                case 'Monthly':
                    this.selectTerms = this.terms.monthly;
                    this.input.terms = this.selectTerms.at(this.selectedTermIndex);
                    break;

                default:
                    this.selectTerms = this.terms.weekly;
                    this.input.terms = this.selectTerms.at(this.selectedTermIndex);
                    break;
            }

            this.termUnit = this.input.frequencies === 'Monthly' ? 'months' : 'weeks';
        },
        onTermChange(event) {
            this.selectedTermIndex = event.target.selectedIndex;
        },
        addToCart(input, interest) {
            let data = {};
            let errors = [];
            let errorText = '';
            let canProceed = true;

            if ($('.product-wrapper').data('is-range')) {
                if (!$('.subitems-list').find('input:checked').length) {
                    canProceed = false;

                    this.$swal.fire({
                        title: 'No products chosen!',
                        text: 'Please choose your products to continue.',
                        icon: 'error',
                    });
                } else {
                    this.product_subitems = JSON.parse(this.$el.getAttribute('data-product-subitems'));
                }
            }

            if (canProceed) {
                if (this.productType === 'voucher') {
                    this.originalPrice = this.input.cash;
                }

                Object.assign(data, {
                    product_type: this.productType,
                    product_attributes: JSON.parse(this.$el.getAttribute('data-product-attributes')),
                    product_subitems: JSON.parse(this.$el.getAttribute('data-product-subitems')),
                    originalPrice: this.originalPrice,
                    frequency: input.frequencies,
                    term: input.terms,
                    cash_price: this.input.cash,
                    deposit: interest.deposit,
                    credit_amount: interest.total_amount_credit,
                    interest_amount: interest.interest_value,
                    payable_amount: interest.total_payable,
                    apr: interest.apr,
                    fixed_rate: interest.fixed_rate,
                    fixed_pa_rate: interest.pa_rate,
                    installment_amount: interest.installments,
                    final_installment_amount: interest.final_installment,
                });

                if (this.productType === 'sofa') {
                    if (!this.swatchNotSelected && this.checkCombinations() > 0) {
                        let selectedCombination = [];

                        this.combinations.forEach((comb) => {
                            if (comb.qty > 0) {
                                selectedCombination.push(comb);
                            }
                        });

                        Object.assign(data, {
                            sofa_style: this.sofaSelection.style,
                            sofa_swatch: this.sofaSelection.swat,
                            sofa_combinations: selectedCombination,
                        });
                    } else {
                        if (this.swatchNotSelected) {
                            errors.push({message: 'Please choose a swatch.'});
                        }

                        if (this.checkCombinations() === 0) {
                            errors.push({message: 'Please choose a combination.'});
                        }

                        errors.forEach((error) => {
                            errorText += `<li>${error.message}</li>`;
                        });

                        this.$swal.fire({
                            title: 'Finish building your sofa',
                            html: `${errorText}`,
                            icon: 'error',
                            confirmButtonText: 'Continue',
                        });

                        return;
                    }
                }

                if (this.productType === 'bed') {
                    if (this.checkBedConfig()) {
                        Object.assign(data, {
                            bed_bedBase: this.bedSelection.bedBase,
                            bed_storage: this.bedSelection.storage,
                            bed_mattress: this.bedSelection.mattress,
                            bed_headboard: this.bedSelection.headboard,
                            bed_swatch: this.bedSelection.swatch,
                        });
                    } else {
                        if (this.bedSelection.bedBaseNotSelected) {
                            errors.push({message: 'bed base'});
                        }

                        if (this.bedSelection.storageNotSelected) {
                            errors.push({message: 'storage'});
                        }

                        if (this.bedSelection.mattressNotSelected) {
                            errors.push({message: 'mattress'});
                        }

                        if (this.bedSelection.headboardNotSelected) {
                            errors.push({message: 'headboard'});
                        }

                        if (this.bedSelection.swatchNotSelected) {
                            errors.push({message: 'swatch'});
                        }

                        errors.forEach((error) => {
                            errorText += `<li>${error.message}</li>`;
                        });

                        this.$swal.fire({
                            title: 'Finish building your bed',
                            html: `${errorText}`,
                            icon: 'error',
                            confirmButtonText: 'Continue',
                        });

                        return;
                    }
                }

                if (this.productType === 'blinds') {
                    axios.post(this.post_url, data).then(response => (
                        window.location.replace('/checkout/blinds')
                    )).catch(error => console.error(error));

                    return;
                }

                if (this.productType === 'car') {
                    axios.post(this.post_url, data).then(response => (
                        window.location.replace('/checkout/car')
                    )).catch(error => console.error(error));

                    return;
                }

                if (this.productType === 'voucher') {
                    axios.post(this.post_url, data).then(response => (
                        window.location.replace('/checkout/voucher')
                    )).catch(error => console.error(error));

                    return;
                }

                axios.post(this.post_url, data).then(response => {
                    this.$swal.fire({
                        title: 'Item added to cart',
                        text: 'Your item has been added to your cart. Would you like to continue shopping?',
                        icon: 'success',
                        showCancelButton: true,
                        confirmButtonText: 'Continue Shopping',
                        cancelButtonText: 'Proceed to Cart',
                        customClass: 'add-to-cart-alert',
                    }).then((result) => {
                        if (result.value) {
                            location.reload();
                        } else {
                            window.location.replace('/cart');
                        }
                    });
                }).catch(error => console.error(error));
            }
        },
        getData() {
            axios.post('/admin/api/sofabuilder/search', {product_id: this.product_id}).then(response => {
                this.styles = response.data?.sofa?.style;
                this.combinations = response.data?.sofa?.combination;

                if (this.combinations) {
                    this.combinations.forEach(combination => {
                        combination.qty = 0;
                        combination.sub_total = 0;
                    });
                }
            }).catch(error => {
                console.error(error);
            });

            axios.post('/admin/api/bedbuilder/search', {}).then(response => (
                this.baseTypes = response.data.bases
            )).catch(error => {
                console.error(error);
            });

            axios.post('/api/products/searchvoucher', {product_id: this.product_id}).then(response => (
                this.voucherPricing = response.data.voucherPricing
            )).catch(error => {
                console.error(error);
            });
        },
        selectSwatch(style, swatch) {
            this.sofaSelection.style = style;
            this.sofaSelection.swatch = swatch;
            this.swatchNotSelected = false;
        },
        incrementCombination(index) {
            if (this.combinations[index].qty < 20) {
                let newCombination = this.combinations[index];

                newCombination.qty = Number(newCombination.qty) + 1;
                newCombination.sub_total = Number(newCombination.price) *
                                           newCombination.qty;
                this.$set(this.combinations, index, newCombination);

                // this.$forceUpdate();
            }
        },
        decrementCombination(index) {
            if (this.combinations[index].qty > 0) {
                let newCombination = this.combinations[index];

                newCombination.qty = Number(newCombination.qty) - 1;
                newCombination.sub_total = Number(newCombination.price) *
                                           newCombination.qty;
                this.$set(this.combinations, index, newCombination);
            }
        },
        checkCombinations() {
            let qty = 0;

            this.combinationSelected = false;
            this.combinations.forEach(combination => {
                qty += Number(combination.qty);
            });

            if (qty > 0) {
                this.combinationSelected = true;
            }

            return qty;
        },
        selectItems(type, data, price = null) {
            switch (type) {
                case 'bedBase':
                    this.bedSelection.bedBase = data;

                    this.getItemPricing(this.bedSelection.bedBase.id, this.bedSelection.bedBase.mattress, 'mattress');
                    this.getItemPricing(this.bedSelection.bedBase.id, this.bedSelection.bedBase.headboard, 'headboard');
                    this.getItemPricing(this.bedSelection.bedBase.id, this.bedSelection.bedBase.style, 'style');

                    this.bedSelection.bedBase.mattress.sort((a, b) => (+a.price > +b.price) ? 1 : -1);
                    this.bedSelection.bedBase.style.sort((a, b) => (+a.price > +b.price) ? 1 : -1);
                    break;

                case 'storage':
                    this.bedSelection.storage = data;
                    break;

                case 'mattress':
                    this.bedSelection.mattress = data;
                    break;

                case 'headboard':
                    this.bedSelection.headboard = data;
                    break;

                case 'swatch':
                    this.bedSelection.swatch = data;
                    this.bedSelection.swatch.price = price;
                    break;
            }
        },
        getItemPricing(baseId, baseItem, type) {
            for (let i in baseItem) {
                if (baseItem[i].prices.length) {
                    for (let j in baseItem[i].prices) {

                        if (baseId == baseItem[i].prices[j].base_id) {
                            baseItem[i].price = baseItem[i].prices[j].price;
                        }
                    }
                }
            }
        },
        resetBedBuilder() {
            this.bedSelection = {
                bedBase: {},
                storage: {},
                mattress: {},
                swatch: {},
                headboard: {},
            };
        },
        changeSelection(type) {
            switch (type) {
                case 'bedBase':
                    this.resetBedBuilder();
                    break;

                case 'storage':
                    this.bedSelection.storage = {};
                    break;

                case 'mattress':
                    this.bedSelection.mattress = {};
                    break;

                case 'swatch':
                    this.bedSelection.swatch = {};
                    break;

                case 'headboard':
                    this.bedSelection.headboard = {};
                    break;
            }
        },
        checkBedConfig() {
            let bed = this.bedSelection;

            return Object.keys(bed.bedBase).length &&
                   Object.keys(bed.storage).length &&
                   Object.keys(bed.mattress).length &&
                   Object.keys(bed.headboard).length &&
                   Object.keys(bed.swatch).length;
        },
    },
    computed: {
        interest() {
            let final = {
                total_value: 0,
                total_payable: 0,
                cumulative_interest: 0,
                installments: 0,
                final_installment: 0,
                pa_rate: 0,
                apr: 0,
                deposit: 0,
                total_amount_credit: 0,
                interest_value: 0,
                fixed_rate: 0,
                display_fixed_rate: this.productType === 'voucher' ? 80 : 36,
                flat_rate: 0,
            };

            this.input.terms = parseInt(this.input.terms);
            if (this.input.cash !== '') {
                this.input.cash = parseFloat(this.input.cash);
            }

            // Vouchers can only be in steps of 50
            if (this.productType === 'voucher') {
                if (this.input.cash > 600) {
                    alert('Cannot finance more than 600 pounds');
                    this.input.cash = 600;
                } else if (this.input.cash < 200) {
                    this.input.cash = 200;
                }

                this.input.cash = Math.round(this.input.cash / 50) * 50;
            }

            final.deposit = this.calculateDeposit();

            // Figure out the Flat Rate & Arrangement Fee
            this.calculateLoanDetails();

            this.input.cash_total = this.input.cash + this.globals.arrangement_fee;
            final.total_amount_credit = this.input.cash + this.globals.arrangement_fee - final.deposit;
            final.fixed_rate = this.globals.flat_rate;
            this.globals.flat_rate = this.globals.flat_rate / 100;

            switch (this.input.frequencies) {
                case 'Weekly':
                case 'Fortnightly':
                case '4 weekly':
                    final.interest_value = final.total_amount_credit * (this.globals.flat_rate * (this.input.terms / 52));
                    break;

                case 'Monthly':
                    final.interest_value = final.total_amount_credit * (this.globals.flat_rate * (this.input.terms / 12));
                    break;
            }

            final.total_value = final.total_amount_credit + final.interest_value;
            final.total_payable = final.total_value + final.deposit;
            final.cumulative_interest = final.interest_value / final.total_amount_credit;

            final.installments = this.calculateInstallments(final.total_value);
            final.final_installment = this.calculateFinalInstallment(final.installments, final.total_value);

            final.pa_rate = (((final.cumulative_interest) / (this.input.terms * 7)) * 365.25) * 100;
            final.apr = this.calculateApr();

            return final;
        },
        sofaTotals() {
            let total = {
                qty: 0,
                price: 0,
            };

            this.combinations.forEach(combination => {
                total.qty += Number(combination.qty);
                total.price += (Number(combination.price) * Number(combination.qty));
            });

            this.input.cash = total.price;

            return total;
        },
        bedTotals() {
            let total = 0;
            let b = this.bedSelection;

            if (b.bedBase.price) {
                total += Number(b.bedBase.price);
            }

            if (b.storage.price) {
                total += Number(b.storage.price);
            }

            if (b.mattress.price) {
                total += Number(b.mattress.price);
            }

            if (b.headboard.price) {
                total += Number(b.headboard.price);
            }

            if (b.swatch.price) {
                total += Number(b.swatch.price);
            }

            this.input.cash = total;

            return total;
        },
    },
    mounted() {
        this.input.cash = this.$el.getAttribute('data-product-price');
        this.productType = this.$el.getAttribute('data-product-type');
        this.post_url = this.$el.getAttribute('data-post-url');
        this.product_id = this.$el.getAttribute('data-product-id');
        this.stock_status_id = this.$el.getAttribute('data-stock_status_id');

        this.getFrequencies();
        this.getTerms();

        if (this.productType !== 'bed' && this.productType !== 'sofa' && this.productType !== 'voucher') {
            let productAttributes = Object.entries(this.product_attributes ?? {});
            let productSubitems = Object.entries(this.product_subitems ?? {});

            productAttributes.forEach(attribute => {
                this.input.cash = Number(this.input.cash) + Number(attribute[1].price);
            });

            productSubitems.forEach(subitem => {
                this.input.cash = Number(this.input.cash) + Number(subitem[1].price);
            });
        }

        if (this.productType === 'blinds') {
            this.input.cash = 0;
        }

        // if (this.product === 'voucher') {
        //     this.input.cash = this.$el.getAttribute('data-product-price');
        // }

        this.getData();
    },
});
